export default {
  started_at: 'Started At',
  finished_at: 'Finished At',
  bot: { tag: 'BOT' },
  logo: { alt: '{{name}} logo' },
  avatars: { alt: '{{name}} avatar' },
  fab: { alt: 'Firesquad Fab' },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  conversation: {
    header: {
      operators: '+{{count}} representatives online',
    },
    guest_setup: {
      title: 'Hello There!',
      desc: 'Before starting a conversation, we will need some info from you.',
      fields: {
        name: 'Name',
        email: 'Email',
        send: 'Send',
      },
    },
    upload: {
      download_file: '{{size}} - {{ext}}',
      download_image: 'Download - {{size}}',
      drop: 'For uploading, drop your files here!',
    },
    conversation: {
      compose_placeholder: 'Type your message here',
    },
    convo_done: 'This conversation is closed',
  },
  error: {
    title: 'Something went wrong',
    message: "Don't worry, the widget will restart shortly!",
  },
  home: {
    conversation: {
      new_conversation: {
        title: 'Start a conversation',
        new_chat_button: 'Chat with us',
        schedule_status: {
          open: "We're online!",
          closed: "We'll answer you soon!",
        },
        schedule_hours: {
          today: 'Our attention schedule for today is {{schedule}}.',
          tomorrow: 'Our attention schedule for tomorrow is {{schedule}}.',
          other: 'Our attention schedule for {{day}} is {{schedule}}.',
        },
        previous_convo: 'Open previous conversations',
      },
      existing: {
        no_content: '(no content)',
        continue_text: 'Continue conversation',
        previous_convo: 'Open previous conversations',
      },
    },
    kb: {
      title: 'Explore our articles and guides',
      search_placeholder: 'Search our articles',
      all_categories: 'See all categories',
    },
    kb_article: {
      written_by: 'Written By',
    },
  },
  knowledge_base: {
    title: 'Knowledge Base',
    creators: {
      creator: '{{users.0.name}}',
      creator_two: '{{users.0.name}} and {{users.1.name}}',
      creator_plural:
        '{{users.0.name}}, {{users.1.name}} and {{countlt2}} others.',
    },
    categories: {
      subtitle: 'Categories',
    },
    articles: {
      written_by: 'Written By',
      search_subtitle: 'Search Articles',
      articles_count: {
        quantity: 'Articles in this category',
        empty: 'No articles in this category',
        and: ' and ',
        others: 'others',
      },
    },
    search: {
      not_found: 'No articles found!',
    },
  },
  status_page: {
    title: 'Status Page',
    main_desc: 'Status Summary',
    issue_header: 'We are currently experiencing technical difficulties.',
    detail_desc: '{{component}} Details',
    home_statuses: {
      operational: 'Status: All Systems Operational',
      issues: 'We are experimenting some issues',
    },
    component_status: {
      OPERATIONAL: 'Operational',
      DEGRADED: 'Degraded Performance',
      PARTIAL_OUTAGE: 'Partial Outage',
      MAJOR_OUTAGE: 'Major Outage',
    },
    statuses: {
      OPERATIONAL: 'All Systems are Operational.',
      DEGRADED: 'Some systems may have slow performance.',
      PARTIAL_OUTAGE: 'There is partial disruption in our systems.',
      MAJOR_OUTAGE: 'There is major disruption in our systems.',
    },
    transfer_statuses: {
      incident: {
        ONGOING: 'An incident has been discovered on our platform.',
        IDENTIFIED:
          'The cause has been identified and we are working on a solution.',
        MONITORING:
          'A fix has been delivered and we are monitoring the platform.',
        RESOLVED: 'This incident has been resolved.',
      },
    },
    last_days: {
      '24h': 'Last 24 Hours',
      '7d': 'Last 7 Days',
      '90d': 'Last 90 Days',
    },
  },
}
